exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1{font-size:1.2em;color:#999;margin-bottom:0}h2{font-size:2em;margin-top:0;padding-top:0}nav a{padding:5px 10px;text-decoration:none;margin-top:10px;display:inline-block;background-color:#eee;border-radius:4px}nav a:visited,a:link{color:#607d8b}nav a:hover{color:#039be5;background-color:#cfd8dc}nav a.active{color:#039be5}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = 2